import CheckBoxOutlineBlankSharp from "@mui/icons-material/CheckBoxOutlineBlankSharp";
import CheckBoxSharp from "@mui/icons-material/CheckBoxSharp";
import IndeterminateCheckBoxSharp from "@mui/icons-material/IndeterminateCheckBoxSharp";
import type { Components, Theme } from "@mui/material";
import { getPaletteColor } from "./util";

declare module "@mui/material/Checkbox" {
  interface CheckboxPropsColorOverrides {
    cyan: true;
    green: true;
    yellow: true;
    orange: true;
    magenta: true;
    purple: true;
    dark: true;
  }
}

export const covestroMuiCheckbox: Components<Theme>["MuiCheckbox"] = {
  defaultProps: {
    disableRipple: true,
    icon: <CheckBoxOutlineBlankSharp />,
    checkedIcon: <CheckBoxSharp />,
    indeterminateIcon: <IndeterminateCheckBoxSharp />,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      "&:hover": {
        color: getPaletteColor(theme, ownerState.color)?.main,
      },
    }),
  },
};
